import React from "react";
import { TableBody, TableRow, Checkbox } from "@mui/material";
import { StyledTableCell, StyledTableRow } from "@/components/styled";
import { FinanceRow } from "@/types";
import { FinanceTableHeader } from "@/utils/financeTableHeaders";
import { getCellValue } from "@/utils/financeUtils";
import EditableNote from "@/components/EditableNote";
import { useNavigate } from "react-router-dom";

interface FinanceTableBodyProps {
  filteredRows: FinanceRow[];
  financeTableHeaders: FinanceTableHeader[];
  isSelected: (id: number) => boolean;
  handleSelectRow: (id: number) => void;
  handleSaveNote: (rowId: number, note: string) => void;
}

const FinanceTableBody: React.FC<FinanceTableBodyProps> = ({
  filteredRows,
  financeTableHeaders,
  isSelected,
  handleSelectRow,
  handleSaveNote,
}) => {
  const navigate = useNavigate();
  return (
    <TableBody>
      {filteredRows.map((row: FinanceRow) => (
        <StyledTableRow
          key={row.id}
          hover
          sx={{ cursor: "pointer" }}
          onClick={() => navigate(`/finance/${row.id}`)}
        >
          <StyledTableCell
            padding="checkbox"
            onClick={(e) => e.stopPropagation()}
          >
            <Checkbox
              checked={isSelected(row.id)}
              onClick={(e) => e.stopPropagation()}
              onChange={() => handleSelectRow(row.id)}
            />
          </StyledTableCell>
          {financeTableHeaders.map((header: FinanceTableHeader) => (
            <StyledTableCell
              key={header.key as string}
              sx={
                header.key === "note"
                  ? {
                      padding: 0,
                      background: "transparent",
                      border: "none",
                      verticalAlign: "middle",
                      width: "100%",
                    }
                  : { padding: "4px 8px" }
              }
              onClick={
                header.key === "note" ? (e) => e.stopPropagation() : undefined
              }
            >
              {header.key === "note" ? (
                <EditableNote
                  isNote={!!row.note}
                  currentNote={row.note || ""}
                  handleDeleteNote={() => handleSaveNote(row.id, "")}
                  handleSaveNote={({ note }) => handleSaveNote(row.id, note)}
                />
              ) : (
                getCellValue(header, row)
              )}
            </StyledTableCell>
          ))}
        </StyledTableRow>
      ))}
    </TableBody>
  );
};

export default FinanceTableBody;
